import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import { getTeamsOverview } from './teams-server';

export function teamsOverviewQueryOptions(userId: string) {
  return queryOptions({
    queryKey: queryKeys.researcherTeamsOverview.byUserId(userId),
    queryFn: () => getTeamsOverview(),
  });
}
